<template>
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
  >
    <path d="M7.68569 0.852196L1.12696 12.7772C0.577137 13.7768 1.30038 15 2.44129 15H15.5587C16.6996 15 17.4229 13.7768 16.8731 12.7772L10.3143 0.852195C9.74445 -0.183969 8.25558 -0.183965 7.68569 0.852196ZM9 4.75004C9.41421 4.75004 9.75 5.08582 9.75 5.50004V9.50004C9.75 9.91425 9.41421 10.25 9 10.25C8.58579 10.25 8.25 9.91425 8.25 9.50004V5.50004C8.25 5.08582 8.58579 4.75004 9 4.75004ZM9.75 11.75C9.75 12.1643 9.41421 12.5 9 12.5C8.58579 12.5 8.25 12.1643 8.25 11.75C8.25 11.3358 8.58579 11 9 11C9.41421 11 9.75 11.3358 9.75 11.75Z" />
  </svg>
</template>
